var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgRecaptcha = function SvgRecaptcha(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#recaptcha_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2650EE",
    d: "M16 8.012c0-.115-.003-.229-.008-.342V1.195l-1.79 1.79A7.973 7.973 0 0 0 8.012.047a7.975 7.975 0 0 0-6.364 3.16l2.934 2.965A3.887 3.887 0 0 1 5.77 4.838c.512-.4 1.238-.726 2.242-.726.121 0 .215.014.284.04a3.868 3.868 0 0 1 2.957 1.781L9.176 8.01c2.63-.01 5.602-.016 6.824.002"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M7.966.047c-.115 0-.23.003-.343.008H1.15l1.79 1.79A7.973 7.973 0 0 0 0 8.035a7.975 7.975 0 0 0 3.16 6.364l2.965-2.934a3.887 3.887 0 0 1-1.333-1.188c-.4-.513-.727-1.238-.727-2.242 0-.122.014-.215.041-.284a3.868 3.868 0 0 1 1.781-2.957l2.077 2.077c-.01-2.63-.017-5.602.001-6.824"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ADB4C1",
    d: "M0 8.034c0 .115.003.23.009.343v6.474l1.79-1.79A7.973 7.973 0 0 0 7.988 16a7.975 7.975 0 0 0 6.364-3.16l-2.934-2.965a3.889 3.889 0 0 1-1.189 1.333c-.512.4-1.238.727-2.242.727a.801.801 0 0 1-.283-.04 3.868 3.868 0 0 1-2.957-1.782l2.076-2.077c-2.63.01-5.602.017-6.823-.001"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "recaptcha_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRecaptcha);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;